module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-names-c32e5d7e7d96e9e5e4832885ddcb7bf9.svg";